import { CdkTrapFocus } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ButtonComponent } from '@shared/button/button.component';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

@Component({
  selector: 'zbp-viewer-control-popover',
  standalone: true,
  imports: [CommonModule, ButtonComponent, CdkTrapFocus],
  templateUrl: './control-popover.component.html',
  styleUrls: ['./control-popover.component.scss'],
  exportAs: 'ControlPopoverComponent',
})
export class ControlPopoverComponent {
  @Input() title: string = 'POPOVER';
  @Output() shouldClosePopover = new EventEmitter<boolean>();

  @ViewChild('popoverContent') popoverContent!: TemplateRef<any>;

  onPopoverShown() {
    // Move focus to the first focusable element in the popover
    setTimeout(() => {
      const popoverBody = document.querySelector('.viewer-control-popover .popover-body .body');
      const firstFocusable = popoverBody?.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ) as HTMLElement;

      if (firstFocusable) {
        firstFocusable.focus();
      }
    });
  }

  closePopover() {
    this.shouldClosePopover.emit(true);
  }

  protected readonly zbpIconNames = zbpIconNames;
}
